import { Help as HelpIcon } from '@mui/icons-material'
import { Box, Tooltip } from '@mui/material'
import React from 'react'

interface KomatsuInputLabelProps {
  label: string
  name: string
  required?: boolean
  error?: boolean
  tooltip?: React.ReactNode
}

const KomatsuInputLabel: React.FC<KomatsuInputLabelProps> = ({
  label,
  name,
  required,
  error,
  tooltip
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0,
        marginBottom: '4px'
      }}
    >
      <Box
        component="label"
        htmlFor={name}
        sx={{
          display: 'block',
          fontSize: '11px',
          letterSpacing: '0.6px',
          fontWeight: 400,
          lineHeight: '16px',
          color: error ? '#FF0000' : '#6B7280'
        }}
      >
        {label}
        {required && <span style={{ color: '#db3131' }}> *</span>}
      </Box>
      {tooltip && (
        <Tooltip title={tooltip}>
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              cursor: 'help',
              marginLeft: '4px'
            }}
          >
            <HelpIcon sx={{ fontSize: '0.875rem', color: 'text.secondary' }} />
          </Box>
        </Tooltip>
      )}
    </Box>
  )
}

export default KomatsuInputLabel
